import React from "react";

const SectionHead = ({ eyebrow, title, lead, center }) => (
  <div className="sec-head reveal" style={center ? { margin: "0 auto 56px", textAlign: "center" } : undefined}>
    <span className="eyebrow" style={center ? { justifyContent: "center" } : undefined}>{eyebrow}</span>
    <h2 className="h-lg">{title}</h2>
    {lead && <p className="lead" style={center ? { margin: "20px auto 0" } : undefined}>{lead}</p>}
  </div>
);

export default SectionHead;
